
export default {
  name: 'Exception404'
}
